/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GameModelDto } from '../../models/game-model-dto';

export interface GameTrackerControllerGetGames$Params {
}

export function gameTrackerControllerGetGames(http: HttpClient, rootUrl: string, params?: GameTrackerControllerGetGames$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GameModelDto>>> {
  const rb = new RequestBuilder(rootUrl, gameTrackerControllerGetGames.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GameModelDto>>;
    })
  );
}

gameTrackerControllerGetGames.PATH = '/game-tracker/games';
